module.exports = __webpack_public_path__ + "29b35bdb.png";